import React from 'react';
import {
  Box,
  Container
} from '@chakra-ui/react';
import Bio from '../../components/sections/bio';

// import BioWithRightMedia from '../../components/sections/biowithrightmedia';
// import EVPColumbia from '../../components/ui/ourcompany/leadership/Joe-Boyle.jpeg';


export default function ColumbiaTabPanel() {
  return (
    <Box>
      <title>Leadership at Columbia</title>
      <meta name="description" content="Executive leadership at Columbia." />
      <Container
        maxW={'80ch'}
        marginX={'auto'}
        paddingX={'clamp(1.09rem, 1rem + 0.47vw, 1.33rem)'}
        sx={{'--flow-lh': '1.6'}}
        marginY={'12'} 
        className='flow'
      >
        {/* <BioWithRightMedia
          title={'JOE BOYLE'}
          subTitle={'EXECUTIVE VICE PRESIDENT, COLUMBIA BRAND PRESIDENT'}
          bio={
              <Text>
                Joe Boyle joined Columbia in 2005 and has served in a variety of
                capacities of increasing leadership and responsibility, including
                brand management, sales, planning, General Merchandising Manager
                of Outerwear, Accessories, Equipment, Collegiate and Licensing,
                Vice President of Apparel Merchandising, and Senior Vice President
                of Columbia Brand Merchandising & Design. He was promoted to
                Executive Vice President, Columbia Brand President in July 2017.
                From 2003 to 2005, Mr. Boyle served in a business development role
                for Robert Trent Jones II Golf Course Architects. Mr. Boyle is a
                fourth-generation member of the company’s founding Boyle family
                and the son of Columbia Chairman, President and CEO Timothy P.
                Boyle.
              </Text>
          }
          media={
            <Image borderRadius={10} src={EVPColumbia} />
          }
        /> */}

        <Bio
          name={'Joe Boyle'}
          title={'Executive Vice President, Columbia Brand President'}
          bio={
            <p>
              Joe Boyle joined Columbia in 2005 and has served in a variety of
                capacities of increasing leadership and responsibility, including
                brand management, sales, planning, General Merchandising Manager
                of Outerwear, Accessories, Equipment, Collegiate and Licensing,
                Vice President of Apparel Merchandising, and Senior Vice President
                of Columbia Brand Merchandising & Design. He was promoted to
                Executive Vice President, Columbia Brand President in July 2017.
                From 2003 to 2005, Mr. Boyle served in a business development role
                for Robert Trent Jones II Golf Course Architects. Mr. Boyle is a
                fourth-generation member of the company’s founding Boyle family
                and the son of Columbia Chairman, President and CEO Timothy P.
                Boyle.
            </p>
          }
        />
      </Container>
    </Box>
  );
}
